export default {
  "agentReport.title": "提现审批",
  "agentReport.thead.index": "#序号",
  "agentReport.thead.statisticsTime": "统计日期",
  "agentReport.thead.statisticsTimezone": "统计时区",
  "agentReport.thead.agentInviteNum": "新增邀请人数",
  "agentReport.thead.agentInviteBet": "邀请投注额",
  "agentReport.thead.agentInviteBonus": "佣金总额",
};
